<template>
	<div class="flex-row fz-14">
		<div class="color-gy-8 mr-16 text-align-right" style="width:60px">{{ info.label }}</div>
		<div class="color-gy-9">{{ info.content }}</div>
	</div>
</template>

<script>
export default {
	props: {
		info: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
};
</script>

<style></style>
